import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { TreeItem } from '../../models/tree-item';
import { ConnectProviderService } from 'app/connect/core/connect-provider.service';
import { I18nService } from 'i18n/i18n.service';

@Component({
  selector: 'connect-replication-detail-log',
  templateUrl: 'connect-replication-detail-log.component.html',
  styleUrls: ['connect-replication-detail-log.component.scss']
})
export class ConnectReplicationDetailLogComponent implements OnInit, OnChanges {

  public showLoading: boolean = false;

  public logs: any = [];

  public titleId: string = this._i18nService.instant('PROVIDERS.REPLICATION.LOGS_SECCTION.ID');
  public titleExecutionDate: string = this._i18nService.instant('PROVIDERS.REPLICATION.LOGS_SECCTION.EXECUTION_DATE');
  public titleExecutionResult: string = this._i18nService.instant('PROVIDERS.REPLICATION.LOGS_SECCTION.EXECUTION_RESULT');
  public titleExecutionMessage: string = this._i18nService.instant('PROVIDERS.REPLICATION.LOGS_SECCTION.EXECUTION_MESSAGE');

  public orderDirection: string = 'desc';
  public orderColumnField: string = 'ExecutionDate';

  @Input() currentItemSelected: TreeItem;

  constructor(private _connectProviderService: ConnectProviderService, private _i18nService: I18nService) {
  }

  ngOnInit() {
  }

  ngOnChanges() {
    this.showLoading = true;
    if (this.currentItemSelected) {
      this.getLog();
    }
  }

  getLog() {
    this._connectProviderService.getLog(this.currentItemSelected.id).subscribe((data) => {
      this.logs = data;
      this.showLoading = false;
    });
  }

  resultDisplay(result) {
    return result ? 'Success' : 'Error';
  }

  returnMessage(dataItem) {
    return dataItem.ExecutionMessage ? dataItem.ExecutionMessage : this.resultDisplay(dataItem.ExecutionSuccess);
  }

  refresh() {
    this.showLoading = true;
    this.getLog();
  }
}
